// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    RouteComponentProps,
    withRouter,
} from 'react-router';
import React from 'react';
import PageHeader from 'common/components/PageHeader/PageHeader';
import { PageSection } from 'common/components/PageHeader/Styles';
import { Translate } from '@plesk/ui-library';
import HAHistoryTable from 'admin/highAvailability/components/HistoryTable/HighAvailabilityHistoryTable';
import { EmptyView } from 'common/components/EmptyView/EmptyView';
import { ICONS } from 'common/constants';
import { connect } from 'react-redux';
import { track } from 'common/analytics/mixpanel';
import { ANALYTICS_EVENTS } from 'common/analytics/constants';

export interface IHighAvailabilityHistoryProps extends RouteComponentProps {}

export const HighAvailabilityHistory: React.FC<IHighAvailabilityHistoryProps> = () => {
    React.useEffect(() => {
        track(ANALYTICS_EVENTS.ADMIN.HIGH_AVAILABILITY_ACTIVITIES.VISIT);
    }, []);

    return (
        <>
            <PageHeader
                title={(
                    <PageSection>
                        <Translate content="highAvailability.activities.title" />
                    </PageSection>
                )}
            />
            <HAHistoryTable
                emptyView={<EmptyView
                    title="highAvailability.activities.list.emptyView.title"
                    icon={ICONS.SCREEN}
                />}
            />
        </>
    );
};

export default withRouter(connect(null, null)(HighAvailabilityHistory));
